/* Product-card thumbnails: hover (mouse) or tap (touch) previews the image. Race-free, no layout shift. */
(function () {
  if (window.__syStable) return; window.__syStable = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var cache = {};
  function preload(src, cb) {
    var c = cache[src];
    if (c && c.done) { cb && cb(); return; }
    if (!c) {
      c = cache[src] = { done: false, cbs: [] };
      var im = new Image();
      im.decoding = 'async';
      var fin = function () { c.done = true; c.cbs.splice(0).forEach(function (f) { f(); }); };
      im.onload = im.onerror = fin;
      im.src = src;
    }
    if (cb) c.cbs.push(cb);
  }
  function show(sw) {
    var card = sw.closest('.sy-card');
    var base = card && card.querySelector('.sy-card__photo:not(.is-fading)');
    var src = sw.getAttribute('data-src');
    if (!base || !src) return;
    card.querySelectorAll('[data-sy-swatch]').forEach(function (b) { b.classList.toggle('is-on', b === sw); });
    var token = card.__syT = (card.__syT || 0) + 1;
    card.querySelectorAll('.is-fading').forEach(function (n) { if (n.getAttribute('src')) base.src = n.getAttribute('src'); n.remove(); });
    if (base.getAttribute('src') === src) return;
    base.removeAttribute('srcset'); base.removeAttribute('sizes');
    preload(src, function () {
      if (card.__syT !== token) return;
      if (reduce.matches) { base.src = src; return; }
      var next = base.cloneNode(false);
      next.className = 'sy-card__photo is-fading';
      next.alt = ''; next.removeAttribute('srcset'); next.removeAttribute('sizes');
      next.style.opacity = '0'; next.style.transition = 'none';
      next.src = src;
      base.parentElement.appendChild(next);
      void next.offsetWidth;
      next.style.transition = 'opacity 160ms cubic-bezier(.2,0,0,1)';
      next.style.opacity = '1';
      setTimeout(function () {
        if (card.__syT === token) base.src = src;
        if (next.parentNode) next.remove();
      }, 190);
    });
  }
  document.addEventListener('pointerdown', function (e) {
    var sw = e.target.closest && e.target.closest('[data-sy-swatch]');
    if (sw) preload(sw.getAttribute('data-src'));
  }, { passive: true, capture: true });
  /* mouse: hover previews (and warms the cache) */
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var sw = e.target.closest && e.target.closest('[data-sy-swatch]');
    if (!sw || sw.contains(e.relatedTarget)) return;
    show(sw);
  }, true);
  /* clicking never navigates; on touch a tap previews the image */
  window.addEventListener('click', function (e) {
    var sw = e.target.closest && e.target.closest('[data-sy-swatch]');
    if (!sw) return;
    e.preventDefault(); e.stopPropagation();
    if (e.pointerType === 'mouse' || (e.detail > 0 && window.matchMedia('(hover:hover)').matches)) return;
    show(sw);
  }, true);
})();
